// DashboardHeader.jsx
export default function DashboardHeader() {
  return (
    <>
      <h5>Datos de la tienda</h5>
      <div className="dashboard-item">
        <span>Nombre</span>
        <strong>Morena Mía Café</strong>
      </div>
      <div className="dashboard-item">
        <span>Ubicación</span>
        <strong>Suba - Bogotá</strong>
      </div>
      <div className="dashboard-item">
        <span>Suscripción</span>
        <strong>Premium</strong>
      </div>
    </>
  );
}
